import Typography from "@mui/material/Typography";
import {ReactNode} from "react";

const PageHeading = ({children}: {children: ReactNode|ReactNode[]}) => {
    return (
        <Typography variant="h1">
            {children}
        </Typography>
    )
};

export default PageHeading;